import { render, staticRenderFns } from "./PageAside.vue?vue&type=template&id=3659e15f&scoped=true"
import script from "./PageAside.vue?vue&type=script&lang=js"
export * from "./PageAside.vue?vue&type=script&lang=js"
import style0 from "./PageAside.vue?vue&type=style&index=0&id=3659e15f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3659e15f",
  null
  
)

export default component.exports